import React from 'react';
import moment from 'moment';
import { processType } from 'constants/process-type';
import { ShowIf } from 'components/utils';
import { Text, TextMessage } from 'components/tt-forms/common';

class ManagerView extends React.Component {

  render() {
    return (
      <div>
        <div className="items-form mb5">
          <div className="row pr10 pl10">

            <Text
              className="col-input"
              label="Giao xử lý:"
              value={this.props.thongTinXuLyGiaiQuyet.quyTrinhXuLy ?
                this.props.thongTinXuLyGiaiQuyet.quyTrinhXuLy : ''} />

            <Text
              red={true}
              className="col-input"
              label="Hạn xử lý:"
              value={this.props.thongTinXuLyGiaiQuyet.thoiHanXuLy ?
                moment(this.props.thongTinXuLyGiaiQuyet.thoiHanXuLy).format('DD/MM/YYYY') : ''} />

            <Text
              className="col-input"
              label="Phòng ban:"
              value={this.props.thongTinXuLyGiaiQuyet.phongBanXuLyChiDinh ?
                this.props.thongTinXuLyGiaiQuyet.phongBanXuLyChiDinh.ten : ''} />

            <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.nextState != null && this.props.thongTinXuLyGiaiQuyet.nextState.type == processType.xuLyDon.processing.lanhDaoGiaoViecTruongPhong &&
              this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh != null && this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh.ten != ''}>
              <Text
                className="col-input"
                label="Trưởng phòng:"
                value={this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh ?
                  this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh.ten : ''} />
            </ShowIf>

            <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.nextState != null && this.props.thongTinXuLyGiaiQuyet.nextState.type == processType.xuLyDon.processing.lanhDaoGiaoViecChuyenVien &&
              this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh != null && this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh.ten != ''}>
              <Text
                className="col-input"
                label="Công chức xử lý:"
                value={this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh ?
                  this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh.ten : ''} />
            </ShowIf>

          </div>
        </div>

        <div className="items-form">
          <div className="row pr10 pl10">
            <TextMessage
              className="col-12"
              value={this.props.thongTinXuLyGiaiQuyet.yKienXuLy || ''}
              label='Nội dung giao việc:' />
          </div>
        </div>
      </div>
    )
  }
}

export default ManagerView;


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-xu-ly/lanh-dao/LanhDaoGiaoViecView.jsx